export default {
  route: {
    dashboard: 'Dashboard',
    UpcomingMeetings: 'Upcoming Meetings',
    ReadMore: 'Read More',
    Client: 'Client',
    Date: 'Date',
    Location: 'Location',
    Time: 'Time',
    Manager: 'Manager',
    Deadline: 'Deadline',
    Delivery: 'Delivery',
    Cost: 'Cost',
    Days: ' Days',
    Of: 'of',
    Remaining: 'Remaining',
    NeedHelp: 'Need Help',
    Completed: 'Completed',
    Pending: 'Pending',
    InProgress: 'in Progress',
    NotStarted: 'Not Started Yet',
    Assignee: 'Assignee',
    RunningTasks: 'Running Tasks',
    Archive: 'Archive',
    DeleteNotification: 'This will permanently delete the task. Continue?',
    Yes: 'Yes',
    No: 'No',
    DeleteCompleted: 'Delete completed',
    DeleteCanceled: 'Delete Canceled',
    Warning: 'Warning',
    AssignTo: 'Assign to',
    taskName: 'Task Νame',
    SaveTask: 'Save Task',
    InputTaskName: 'Please input Task name',
    FormMinLength: 'Min Length should be 3 characters',
    FormAddAssignee: 'Please select Assignee',
    Meeting: 'No Meetings',
    noFiles: 'No Files',
    Months: 'Months',
    Month: 'Month',
    PendingTickers: 'Pending Tickers',
    LatestOrders: 'Latest Orders',
    NoData: 'No Data',
    ArchiveTask: 'This will archive your task.Continue?',
    ArchiveCompleted: 'Archive Completed',
    ArchiveCanceled: 'Archive Canceled',
    AllActivity: 'All Activity',
    CommunicationLog: 'Communication Log',
    Transactions: 'Transactions',
    SystemLog: 'System Log',
    Outstanding: 'Outstanding',
    Paid: 'Paid',
    Files: 'Files',
    Upload: 'Upload',
    SelectUser: 'Select User',
    LogOut: 'Log out'
  },
  tips: {
    LatestOrdersTxt: 'Here is a list of the orders in the past 30 days.',
    PendingTicketsTxt: 'Below is the list of the pending (not yet resolved) tickets.',
    OutstandingTxt: 'Here is a list of the outstanding invoices. In case the collections are not directly related with specific invoices, there may be invoices on this list that have been paid but are showing us outstanding.',
    TasksTxt: 'You can drag & drop the tasks below to change priorities. Completed tasks can be archived and moved on the equivalent tab.',
    TasksArchTxt: 'Here you can find all the completed and archived tasks.'
  },
  tables: {
    Task: 'Task',
    Project: 'Project',
    Assignee: 'Assignee',
    Complete: 'Completed',
    Items: 'Items',
    TotalAmount: 'Total Amount',
    InsertedBy: 'Entered Βy',
    LastStatus: 'Last Status',
    Description: 'Description',
    Priority: 'Priority',
    TicketType: 'Ticket type',
    From: 'From',
    To: 'To',
    Resolved: 'Resolved',
    FullName: 'Full Name',
    Channel: 'Channel',
    Avatar: 'Avatar',
    Filename: 'Filename',
    DateAdded: 'Date Added',
    Actions: 'Actions',
    Transactiontype: 'Transaction type',
    LocationIp: 'Location / Ip',
    DaysAgo: 'Days ago'
  },
  transactionsType: {
    Buy: 'Buy',
    Purchases: 'Purchase',
    Sales: 'Sales',
    CollectionsPayments: 'Collections-Payments',
    Expenses: 'Expenses',
    Services: 'Services',
    Inventory: 'Inventory',
    PurchasesOrders: 'Purchases Orders',
    SalesOffers: 'Sales Offers',
    SalesOrder: 'Sales Order',
    ExpensesOrders: 'ExpensesOrders',
    ServicesOffers: 'ServicesOffers',
    ServicesOrders: 'Services Orders',
    ThirdPartyItems: 'Third Party Items',
    ItemsToOthers: 'Items To Others',
    BulkMovementsOfSecurities: 'Bulk Movements Of Securities'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js